import { combineReducers } from 'redux';

import { AllActions } from '../actions/allActions';
import { InternalActionTypes } from '../constants/actionTypes';
import { NormalizedClient } from '../models/normalized/normalizedClient';
import { ById } from '../store/normalizedState';

import { FETCH_CLIENT_SUCCESS } from 'api/clients/clients.actions';
import * as ReducerHelper from './reducerHelper';

function allIdsReducer(state: string[] = [], action: AllActions): string[] {
  switch (action.type) {
    case InternalActionTypes.ActiveClientsLoaded:
      return ReducerHelper.addAllIds(state, action.result.entities.clients);
    case InternalActionTypes.ClientCreated:
      return ReducerHelper.addAllIds(state, action.result.entities.clients);
    case InternalActionTypes.ClientEdited:
    case InternalActionTypes.VideoReminderEmailSent:
    case FETCH_CLIENT_SUCCESS:
      return ReducerHelper.addAllIds(state, action.result.entities.clients);
    case InternalActionTypes.EventLoaded:
      return ReducerHelper.addAllIds(state, action.result.entities.clients);
    case InternalActionTypes.EventCreated:
      return ReducerHelper.addAllIds(state, action.result.entities.clients);
    case InternalActionTypes.EventEdited:
      return ReducerHelper.addAllIds(state, action.result.entities.clients);
    case InternalActionTypes.EventVideosLoaded:
      return ReducerHelper.addAllIds(state, action.result.entities.clients);
    case InternalActionTypes.EventActionsLoaded:
      return ReducerHelper.addAllIds(state, action.result.entities.clients);
    case InternalActionTypes.ClientArchived:
      return ReducerHelper.removeId(state, action.result.result);
    case InternalActionTypes.ClientUnarchived:
      return ReducerHelper.addAllIds(state, action.result.entities.clients);
    default:
      return state;
  }
}

function byIdReducer(state: ById<NormalizedClient> = {}, action: AllActions): ById<NormalizedClient> {
  switch (action.type) {
    case InternalActionTypes.ActiveClientsLoaded:
      return ReducerHelper.updateAll(state, action.result.entities.clients);
    case InternalActionTypes.ClientCreated:
      return ReducerHelper.updateItemByFunc(
        state,
        (i: any) => ({ ...i, ...action.result.entities.clients[action.result.result.toLowerCase()] }),
        action.result.result.toLowerCase(),
      );
    case InternalActionTypes.ClientEdited:
    case InternalActionTypes.VideoReminderEmailSent:
    case FETCH_CLIENT_SUCCESS:
      return ReducerHelper.updateAll(state, action.result.entities.clients);
    case InternalActionTypes.EventLoaded:
      return ReducerHelper.updateAll(state, action.result.entities.clients);
    case InternalActionTypes.EventCreated:
      return ReducerHelper.updateAll(state, action.result.entities.clients);
    case InternalActionTypes.EventEdited:
      return ReducerHelper.updateAll(state, action.result.entities.clients);
    case InternalActionTypes.EventVideosLoaded:
      return ReducerHelper.updateAll(state, action.result.entities.clients);
    case InternalActionTypes.EventActionsLoaded:
      return ReducerHelper.updateAll(state, action.result.entities.clients);
    case InternalActionTypes.ClientArchived:
      return ReducerHelper.removeItem(state, action.result.result);
    case InternalActionTypes.ClientUnarchived:
      return ReducerHelper.updateAll(state, action.result.entities.clients);
    default:
      return state;
  }
}

export const clientsReducer = combineReducers({
  allIds: allIdsReducer,
  byId: byIdReducer,
});
